import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import { UserBasicInfoFragmentDoc } from '../../../communities/components/GroupMembersList/__generated__/user.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserUploadedFilesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserUploadedFilesQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, uploadedFiles: Array<{ __typename?: 'UserUploadedFile', id: string, uuid: string, type: Types.FileType, name?: string | null, url: string, createdAt: number, posts: { __typename?: 'BasePost', selectedUsers?: Array<{ __typename?: 'PostAccess', user: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null } }> } };


export const GetUserUploadedFilesDocument = gql`
    query GetUserUploadedFiles {
  currentUser {
    id
    uploadedFiles {
      id
      uuid
      type
      name
      url
      createdAt
      posts {
        selectedUsers {
          user {
            ...UserBasicInfo
          }
        }
      }
    }
  }
}
    ${UserBasicInfoFragmentDoc}`;

/**
 * __useGetUserUploadedFilesQuery__
 *
 * To run a query within a React component, call `useGetUserUploadedFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserUploadedFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserUploadedFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserUploadedFilesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserUploadedFilesQuery, GetUserUploadedFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserUploadedFilesQuery, GetUserUploadedFilesQueryVariables>(GetUserUploadedFilesDocument, options);
      }
export function useGetUserUploadedFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserUploadedFilesQuery, GetUserUploadedFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserUploadedFilesQuery, GetUserUploadedFilesQueryVariables>(GetUserUploadedFilesDocument, options);
        }
// @ts-ignore
export function useGetUserUploadedFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserUploadedFilesQuery, GetUserUploadedFilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserUploadedFilesQuery, GetUserUploadedFilesQueryVariables>;
export function useGetUserUploadedFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserUploadedFilesQuery, GetUserUploadedFilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserUploadedFilesQuery | undefined, GetUserUploadedFilesQueryVariables>;
export function useGetUserUploadedFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserUploadedFilesQuery, GetUserUploadedFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserUploadedFilesQuery, GetUserUploadedFilesQueryVariables>(GetUserUploadedFilesDocument, options);
        }
export type GetUserUploadedFilesQueryHookResult = ReturnType<typeof useGetUserUploadedFilesQuery>;
export type GetUserUploadedFilesLazyQueryHookResult = ReturnType<typeof useGetUserUploadedFilesLazyQuery>;
export type GetUserUploadedFilesSuspenseQueryHookResult = ReturnType<typeof useGetUserUploadedFilesSuspenseQuery>;
export type GetUserUploadedFilesQueryResult = Apollo.QueryResult<GetUserUploadedFilesQuery, GetUserUploadedFilesQueryVariables>;